<div class="navigation">
  <div
    *ngFor="let page of pages"
    class="navigation-item"
    [ngClass]="{
      selected: selectedPage === page.type,
      'is-in-payments': isInPayments,
    }"
    (click)="selectPage(page.type)"
  >
    {{ page.value | translate }}
  </div>
</div>
<div class="overview-container">
  <app-expense-overview
    [project]="project"
    *ngIf="selectedPage === 'expenses'"
  ></app-expense-overview>
  <app-estimates-and-invoices
    [project]="project"
    [isInPayments]="isInPayments"
    *ngIf="selectedPage === 'invoices'"
  ></app-estimates-and-invoices>
</div>
